import { Navigate } from 'react-router-dom';
import { ANALYTICS_ORDERS } from '../../config/routes';

export default () => <Navigate to={ANALYTICS_ORDERS} replace />;
